import { render } from "./index.vue?vue&type=template&id=712644e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=712644e8&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712644e8"],['__file',"src/views/ticket/order/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "712644e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('712644e8', __exports__)) {
    console.log('reload')
    api.reload('712644e8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=712644e8&scoped=true", () => {
    console.log('re-render')
    api.rerender('712644e8', render)
  })

}


export default __exports__